import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Card } from 'reactstrap';
import { lifecycle, toClass } from 'recompose';
import Alerts from '../../Alerts';
import ActivityCardBody from '../ActivityCardBody';
import withActivity from '../withActivity';
import ActivityMapAndChartContainer from './ActivityMapAndChartContainer';
import './ActivityScene.scss';

/** Activity panel which populates with activity data by id */
const ActivityCardBodyWithData = withActivity(ActivityCardBody);

/** Extracts the activity id from the current route and passes it to the activity panel */
const ActivityScene = ({ match }: RouteComponentProps<any>) => {
    const id: string | null =
        match.params && match.params.activityId
            ? match.params.activityId.toString()
            : null;

    if (!id) {
        return <p>No activity specified</p>;
    }

    return (
        <>
            <Alerts key="alerts" />
            <div className="activity-scene" key="scene">
                <Card className="run-info">
                    <ActivityCardBodyWithData id={id} />
                </Card>
                <ActivityMapAndChartContainer id={id} />
            </div>
        </>
    );
};

// Convert the scene to a class to keep react router happy
export default toClass(
    lifecycle({
        componentDidMount() {
            // Return to the top of the page,
            // in case the user has scrolled down the list of activities
            if ((process as any).browser) {
                (window as any).scrollTo(0, 0);
            }
        }
    })(ActivityScene)
);



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityScene/index.tsx